import { useEffect, useRef } from 'react';

const useScrollReveal = (options = {}) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      node.classList.add('is-visible');
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (!options.repeat) observer.unobserve(entry.target);
          } else if (options.repeat) {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: options.threshold ?? 0.15,
        rootMargin: options.rootMargin ?? '0px 0px -80px 0px',
      }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [options.repeat, options.threshold, options.rootMargin]);

  return ref;
};

export default useScrollReveal;
